import request from '@/utils/request'

export function addImageFile(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/addImageFile",
    method: "post",
    data
  });
}
export function qryImageFile(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/qryImageFile",
    method: "post",
    data
  });
}

export function delImageFile(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/delImageFile",
    method: "post",
    data
  });
}
export function renameImageFile(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/renameImageFile",
    method: "post",
    data
  });
}

export function qryImage(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/qryImage",
    method: "post",
    data
  });
}

export function delImageBatch(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/delImageBatch",
    method: "post",
    data
  });
}
export function moveImageBatch(data) {
  return request({
    url: "/apis/sra/spc/users/signup/image/moveImageBatch",
    method: "post",
    data
  });
}
